<template>
    <div>
        <div class="container-fluid">
            <!-- Head -->
            <div class="d-flex align-items-center justify-content-between pt-4 mb-4">
                <div class="d-block">
                    <div class="h1-lg display-tektur m-0">Sekolah</div>
                </div>
                <div class="d-block">
                    <button type="button" v-on:click="$parent.$parent.school_form();" class="btn btn-primary btn-lg btn-s-1">
                        <div class="btn-s-1-inner"><i class="fa-solid fa-circle-plus fa-lg me-3"></i>Tambah Data</div>
                    </button>
                </div>
            </div>
        </div>

        <!-- Data -->
        <div class="card rounded-0 m-0 bg-card-trans-3">
            <div class="card-header">
                <div class="input-group input-group-flush input-group-merge input-group-reverse">
                    <input class="form-control list-search" type="search" placeholder="Cari data sekolah disini..." v-model="keywords" v-on:keyup.enter="getData">
                        <span class="input-group-text">
                        <i class="fa-solid fa-search"></i>
                    </span>
                </div>
            </div>
        </div>

        <div v-if="dataFetch" class="container-fluid mt-4">
            <div class="card">
                <div class="card-body">
                    <div class="d-block text-center py-4">
                        <div class="d-block mb-2 text-muted"><i class="fa-solid fa-spin fa-spinner fa-lg"></i></div>
                        <div class="d-block text-sm text-muted ">Loading...</div>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="!dataFetch && dataList.length > 0" class="card rounded-0 m-0 bg-card-trans-3">
            <div data-simplebar class="table-responsive" style="overflow-y:auto; height:72.9vh;">
                <table class="table table-sm table-hover card-table th-sticky">
                    <thead>
                        <tr>
                            <th class="text-center">No</th>
                            <th>Nama</th>
                            <th>Kota/Kabupaten</th>
                            <th>Provinsi</th>
                            <th>NPSN</th>
                            <th class="text-center">Nilai Index</th>
                            <th>Status</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody class="list fs-base">
                        <tr v-for="(item, index) in dataList" :key="index">
                            <td class="text-center">
                                {{ (index + 1) + (pagination.current_page - 1) * pagination.limit }}
                            </td>
                            <td class="font-bold data-nama-sekolah">
                                <div class="d-block font-bold">{{item.name}}</div>
                                <span v-if="item.relation" class="badge bg-primary"><i class="fa-solid fa-link me-2"></i>Sudah Berelasi</span>
                            </td>
                            <td>{{ item.city_name }}</td>
                            <td>{{ item.province_name }}</td>
                            <td>{{ item.npsn }}</td>
                            <td class="text-center">
                                <div class="box-score">
                                    <span>{{ item.index_score }}</span>
                                </div>
                            </td>
                            <td>{{item.partner == 1 ? 'Mitra':'Bukan Mitra'}}</td>
                            <td>
                                <div class="d-flex align-items-center">
                                    <button v-on:click="$parent.$parent.school_form(item.id);" type="button" class="btn btn-white-naked btn-sm me-2" data-bs-toggle="tooltip" data-bs-placement="top" title="Edit">
                                        <i class="fa-solid fa-pencil"></i>
                                    </button>
                                    <button v-on:click="deleteData(item.id)" type="button" class="btn btn-white-naked btn-sm text-danger" data-bs-toggle="tooltip" data-bs-placement="top" title="Delete">
                                        <i class="fa-solid fa-trash-can"></i>
                                    </button>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div aria-label="navigation" class="card-footer d-flex justify-content-between">

                <!-- Pagination (prev) -->
                <ul class="list-pagination-prev pagination pagination-tabs card-pagination">
                    <li class="page-item">
                        <a class="page-link ps-0 pe-4 border-end border-c-1" :class="pagination.current_page <= 1 ? 'disabled':''" href="javascript:void(0)" v-on:click="pagination_handle('prev')">
                            <i class="fa-solid fa-angle-left me-3"></i>Sebelumnya
                        </a>
                    </li>
                </ul>

                <v-pagination v-model="pagination.current_page" :page-count="pagination.total_pages" :classes="pagination.style" :labels="pagination.anchor_text" v-on:change="getData()"></v-pagination>

                <!-- Pagination (next) -->
                <ul class="list-pagination-next pagination pagination-tabs card-pagination">
                    <li class="page-item">
                        <a class="page-link ps-4 pe-0 border-start border-c-1" :class="pagination.current_page >= pagination.total_pages ? 'disabled':''" href="javascript:void(0)" v-on:click="pagination_handle('next')">
                            Selanjutnya<i class="fa-solid fa-angle-right ms-3"></i>
                        </a>
                    </li>
                </ul>

            </div>            
        </div>

        <!-- Empty -->
        <div v-if="!dataFetch && emptyState" class="container-fluid mt-4">
            <div class="card">
                <div class="card-body">
                    <div class="d-block text-center py-4">
                        <div class="d-block mb-2 text-pink"><i class="fa-solid fa-triangle-exclamation fa-lg"></i></div>
                        <div class="d-block text-sm text-muted ">Data tidak ditemukan.</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import vPagination from 'vue-plain-pagination'
export default {
    name: 'SchoolMain',
    metaInfo: {
        title: 'Sekolah',
        titleTemplate: '%s - Rasionalisasi Rapor'
    },
    components: {
        vPagination
    },
    data() {
        return {
            emptyState  : false,
            dataFetch   : false,
            dataList    : [],
            keywords    : "",
            pagination: {
                current_page    : 1,
                total_pages     : 0,
                limit           : 10,
                style: {
                    ul: 'list-pagination pagination pagination-tabs card-pagination',
                    li: 'page-item',
                    a: 'page',
                    liActive: 'active',
                    liDisable: 'disabled',
                    button: 'page-link'                
                },
                anchor_text: {
                    first: '',
                    prev: '',
                    next: '',
                    last: ''
                }
            }
        }
    },
    created() {
        this.getData();
    },
    methods: {
        getData: function() {
            let uri         = process.env.VUE_APP_APIHOST+'school/list';

            this.dataFetch  = true;                
            this.$http.get(uri,{
                params : {
                    keywords : this.keywords,
                    page     : this.pagination.current_page,
                    limit    : this.pagination.limit
                }
            }).then(res => {
                this.emptyState                 = false;
                this.dataFetch                  = false;                
                this.dataList                   = res.data.data;
                this.pagination.total_pages     = res.data.total_page;

                if(this.dataList.length < 1) {
                    this.emptyState = true;
                }
            });
        },
        pagination_handle: function(params) {
            if(params == 'next') {
                if(this.pagination.current_page < this.pagination.total_pages) {
                    this.pagination.current_page = this.pagination.current_page+1;
                    this.getData();
                }
            }

            if(params == 'prev') {
                if(this.pagination.current_page > 1) {
                    this.pagination.current_page = this.pagination.current_page-1;
                    this.getData();
                }
            }
        },
        deleteData: function (id) {
            this.$swal({
                icon: 'info',
                title: 'Hapus Data',
                text: 'Apakah kamu yakin ingin menghapus data ini?',
                confirmButtonText: 'Hapus',
                showCancelButton: true,
                cancelButtonText: 'Batal',
            }).then((result) => {
            if (result.value) {
                this.$http.post(process.env.VUE_APP_APIHOST + 'school/delete', {
                    id: id
                })
                .then(response => {
                    if (response.data.status) {
                        this.$swal({
                            icon: 'success',
                            title: 'Success',
                            text: response.data.message,
                            confirmButtonText: 'OK'
                        }).then((result) => {
                            if (result.value) {
                                this.getData();
                            }
                        });
                    } else {
                    this.$swal({
                        icon: 'warning',
                        title: 'Ups!',
                        text: response.data.message,
                    });
                    }
                })
            }
            });
        }
    }
}
</script>
